// extracted by mini-css-extract-plugin
export default {"button":"Header_button__TxjhR","text":"Header_text__H6a+X","icon":"Header_icon__02R3Z"};